import React from 'react'
import { useGlobalState } from '@/state'

import ProfileCompletion from '@/pages/Users/ProfileCompletion'
import ProfileGeneralBasic from '@/pages/Users/ProfileGeneralBasic'
import ProfileCreatorKinds from '@/pages/Users/ProfileCreatorKinds'
import ProfileLinks from '@/pages/Users/ProfileLinks'

// Profile tab: who you are. Work details live on the next tab.
const ProfileGeneral = () => {
  const [user] = useGlobalState('userContainerUser')
  return <div className='space-y-10'>
    <ProfileCompletion user={user} />
    <ProfileGeneralBasic />
    <ProfileCreatorKinds />
    <ProfileLinks />
  </div>
}

export default ProfileGeneral
